import { 
  SET_AMOUNT_SLIDER,
  SET_PAYMENT_SLIDER,
  SET_TABLE,
  SET_TABLE_RECAP,
  SET_CURRENT_SIMULATION,
  SET_TOKEN,
  SET_MODAL,
  SET_LOADER,
  SET_SKIP_SIMULATION,
  SET_SKIP_RECAP,
  SET_USER_DATA, 
  SET_PASSED_DATA,
  SET_INTERNAL_THEME,
  SET_IS_SPEED_APP
} from '../constants/index';
import { INTERNAL_THEME } from '../../helpers/constants';
import { convertValueFromLogarithmicBehaviour } from '../../helpers/utils';

const initialSimulation = {
  purpose: {
    index: "45",
    icon: "ct-icon-obiettivo-viaggio",
    text: "Spese familiari",
    code: "FAM",
  },
  amount: {
    value: 10000,
    min: 1000,
    max: 30000,
    minAmountDue: 12682.64,
    maxAmountDue: 15048.42,
  },
  payment: {
    value: 175,
    min: 175,
    max: 475,
    minPaymentDue: 152.46,
    maxPaymentDue: 179.96,
  },
  numberOfInstallments: {
    min: 69,
    max: 83,
  },
  TAN: {
    min: 6.90,
    max: 11.89,
  },
  TAEG: {
    min: 7.35,
    max: 13.43,
  },
  others: {
    transparencyDuty: 0,
    administrationFees: 40.00,
    administrationFeesMax: 150.00,
    stampDuty: 25.10,
    stampDutyMax: 25.38,
  }
}

export const initialState = {
  modals: {
    moreInfo: {
      isVisible: false,
    }
  },
  sliders: {
    amount: {
      initialValue: {
        real: convertValueFromLogarithmicBehaviour({ currentValue: initialSimulation["amount"]["value"], min: initialSimulation["amount"]["min"], max: initialSimulation["amount"]["max"], step: 10 }, 5),
        shown: initialSimulation["amount"]["value"],
      },
      currentValue: {
        real: convertValueFromLogarithmicBehaviour({ currentValue: initialSimulation["amount"]["value"], min: initialSimulation["amount"]["min"], max: initialSimulation["amount"]["max"], step: 10 }, 5),
        shown: initialSimulation["amount"]["value"],
      },
      min: initialSimulation["amount"]["min"],
      max: initialSimulation["amount"]["max"],
      step: 1000,
      reinitialize: false,
    },
    payment: {
      initialValue: {
        real: convertValueFromLogarithmicBehaviour({ currentValue: initialSimulation["payment"]["value"], min: initialSimulation["payment"]["min"], max: initialSimulation["payment"]["max"], step: 1 }, 5),
        shown: initialSimulation["payment"]["value"],
      },
      currentValue: {
        real: convertValueFromLogarithmicBehaviour({ currentValue: initialSimulation["payment"]["value"], min: initialSimulation["payment"]["min"], max: initialSimulation["payment"]["max"], step: 1 }, 5),
        shown: initialSimulation["payment"]["value"],
      },
      min: initialSimulation["payment"]["min"],
      max: initialSimulation["payment"]["max"],
      step: 5,
      reinitialize: false,
      frontLayer: {},
    },
  },
  table: {
    recap: {},
    complete: []
  },
  currentSimulation: {
    purpose: {
      index: initialSimulation["purpose"]["index"],
      icon: initialSimulation["purpose"]["icon"],
      text: initialSimulation["purpose"]["text"],
      code: initialSimulation["purpose"]["code"],
    },
    amount: {
      current: initialSimulation["amount"]["value"],
      min: initialSimulation["amount"]["minAmountDue"],
      max: initialSimulation["amount"]["maxAmountDue"],
    },
    payment: {
      current: initialSimulation["payment"]["value"],
      min: initialSimulation["payment"]["minPaymentDue"],
      max: initialSimulation["payment"]["maxPaymentDue"],
    },
    numberOfInstallments: {
      min: initialSimulation["numberOfInstallments"]["min"],
      max: initialSimulation["numberOfInstallments"]["max"],
    },
    TAN: {
      min: initialSimulation["TAN"]["min"],
      max: initialSimulation["TAN"]["max"],
    },
    TAEG: {
      min: initialSimulation["TAEG"]["min"],
      max: initialSimulation["TAEG"]["max"],
    },
    others: {
      transparencyDuty: initialSimulation["others"]["transparencyDuty"],
      administrationFees: initialSimulation["others"]["administrationFees"],
      //TODO: controllare valore qua;
      administrationFeesMax: initialSimulation["others"]["administrationFeesMax"],
      stampDuty: initialSimulation["others"]["stampDuty"],
      stampDutyMax: initialSimulation["others"]["stampDutyMax"],
    }
  },
  token: null,
  skip: {
    simulation: false,
    recap: false,
  },
  passed: {
    fromSimulation: false
  },
  user: {
    tel: "",
    cf: "",
    token: "",
    tokenOTP: ""
  },
  isSpeedApp: false,
  internalTheme: INTERNAL_THEME.COMPASS_BASE_SIMULATOR,
  loader: {
    visible: false
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AMOUNT_SLIDER: {
      const newAmount = { ...state.sliders.amount, ...action.payload};
      
      return {
        ...state,
        sliders: {
          ...state.sliders,
          amount: newAmount,
        }
      }
    }
    case SET_PAYMENT_SLIDER: {
      const newPayment = { ...state.sliders.payment, ...action.payload};
      
      return {
        ...state,
        sliders: {
          ...state.sliders,
          payment: newPayment,
        }
      }
    }
    case SET_TABLE: {
      return {
        ...state,
        table: {
          ...state.table,
          complete: action.payload,
        }
      }
    }
    case SET_TABLE_RECAP: {
      const newTableRecap = { ...state.table.recap, ...action.payload};
      
      return {
        ...state,
        table: {
          ...state.table,
          recap: newTableRecap
        }
      }
    }
    case SET_CURRENT_SIMULATION: {
      const newSimulation = { ...state.currentSimulation, ...action.payload};
      
      return {
        ...state,
        currentSimulation: newSimulation,
      }
    }
    case SET_TOKEN: {
      return {
        ...state,
        token: action.payload,
      }
    }
    case SET_MODAL: {
      const { modal, options } = action.payload;
      const newModal = { ...state.modals[modal], ...options};

      return {
        ...state,
        modals: {
          ...state.modals,
          [modal]: newModal
        }
      }
    }
    case SET_SKIP_SIMULATION: {
      return {
        ...state,
        skip: {
          ...state.skip,
          simulation: action.payload,
        },
      }
    }
    case SET_SKIP_RECAP: {
      return {
        ...state,
        skip: {
          ...state.skip,
          recap: action.payload,
        },
      }
    }
    case SET_PASSED_DATA: {
      return {
        ...state,
        passed: action.payload,
      }
    }
    case SET_USER_DATA: {
      return {
        ...state,
        user: action.payload,
      }
    }
    case SET_INTERNAL_THEME: {
      return {
        ...state,
        internalTheme: action.payload,
      }
    }
    case SET_IS_SPEED_APP: {
      return {
        ...state,
        isSpeedApp: action.payload || false,
      }
    }
    case SET_LOADER: {
      return {
        ...state,
        loader: action.payload
      }
    }
    default: {
      return state;
    }
  }
}